import { accessDenied } from "./lib/query-persistence";
import { initTelemetry, reportError, watchWebErrors } from "./lib/telemetry";
import { configureKeyboardViewport } from "./lib/keyboard";
import React from "react";
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider, QueryCache, onlineManager } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { NativeCompatibility } from "./NativeCompatibility";
import { ErrorBoundary } from "./ErrorBoundary";
import { App } from "./App";
import "./tokens.css";
import "./styles.css";
import { watchConnectivity } from "./lib/native-connectivity";
import { watchNativeDiagnostics } from "./lib/native-diagnostics";
import { watchSystemAppearance } from "./lib/system-appearance";
void initTelemetry();
const stopWebErrors = watchWebErrors();
if (import.meta.hot) import.meta.hot.dispose(stopWebErrors);
onlineManager.setEventListener(watchConnectivity);
void configureKeyboardViewport().catch(error => reportError(error, "keyboard_configuration"));
const stopAppearance = watchSystemAppearance();
if (import.meta.hot) import.meta.hot.dispose(stopAppearance);
const stopDiagnostics = watchNativeDiagnostics();
if (import.meta.hot) import.meta.hot.dispose(stopDiagnostics);
const queryClient = new QueryClient({
  queryCache: new QueryCache({ onError: (error, query) => {
    if (accessDenied(error)) query.setState({ data: undefined });
    reportError(error, "query_load", { source: String(query.queryKey[0]).replace(/[^a-zA-Z0-9_-]/g, "_").slice(0,60) });
  } }),
  defaultOptions: {
    queries: { staleTime: 60_000, gcTime: 24 * 60 * 60 * 1000, retry: 1, refetchOnWindowFocus: true },
    mutations: { retry: false },
  },
});
createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <ErrorBoundary>
          <NativeCompatibility>
            <App />
          </NativeCompatibility>
        </ErrorBoundary>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
